/**
 * @class AppOverlayTypes
 * @name types
 * @memberof Mojito.Applications.Sports.AppOverlay
 */
export default {
    /**
     * Items to display within overlay.
     *
     * @readonly
     * @enum {string}
     * @memberof Mojito.Applications.Sports.AppOverlay.types
     * @public
     */
    APP_OVERLAY_ITEMS: {
        SLIDING_BETSLIP: 'slidingBetslip',
        SLIDING_OPEN_BETS: 'slidingOpenBets',
        AZ_MENU: 'azMenu',
        MY_ACCOUNT: 'myAccount',
        DIALOG_MESSAGE: 'dialogMessage',
        ALERT_MESSAGE: 'alertMessage',
        LOGIN: 'login',
        FOREIGN_WINDOW: 'foreignWindow',
        INACTIVITY: 'inactivity',
        TOAST_ITEMS: 'toastItems',
        QUICK_NAVIGATION: 'quickNavigation',
        SAVED_BET_DETAILS: 'savedBetDetails',
        YOUR_BETS_DETAILS: 'yourBetsDetails',
    },

    /**
     * Toast items to display within overlay in toast container.
     *
     * @readonly
     * @enum {string}
     * @memberof Mojito.Applications.Sports.AppOverlay.types
     * @public
     */
    APP_OVERLAY_TOAST_ITEMS: {
        SIMPLE_TOAST: 'simpleToast',
        SELECTIONS_LIMIT_BREACH_TOAST: 'selectionsLimitBreachToast',
    },
};
